<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpFormSelect2
    name="partner"
    v-model="editor.partner"
    bind-object
    taggable
    :dataSource="b_2248226175642056_dataSource"
    valueField="id"
    textField="name"
    clearable
    :optionTemplate="b_2248226175642056_optionTemplate"
    use-option-template-for-selected-option
    :readonly="editor.isReadonly"
    @optionSelected="evh_2248226175642056_optionSelected($event, {})"
  >
  </ItpFormSelect2>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcRegisterEntryPartnerSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  onOptionSelected(...args: any[]) {
    const [{ option, value }] = args;
    if (_.isString(option)) {
      this.editor.partner = { name: option };
    }
  }

  @Prop({
    required: true,
    type: Object,
  })
  editor!: object;

  @Watch('editor')
  onEditor(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("editor")
  }

  messages!: any;
  ux!: any;
  b_2248226175642056_dataSource!: any;

  async $$load_b_2248226175642056_dataSource() {
    return {
      name: "suggest_company",
      parameters: {
        exclude: [this.editor.version.company_id],
      }
      ,
    }
  }

  b_2248226175642056_optionTemplate!: any;
  dataMembers = ['messages', 'ux', 'b_2248226175642056_dataSource', 'b_2248226175642056_optionTemplate'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          searchPlaceholder: this.$fn.pgettext("Register", "Search for partner"),
        }
        ,
        ux: null,
        b_2248226175642056_dataSource: null,
        b_2248226175642056_optionTemplate: "<div>\n\
  <span v-if=\"!option.id\">{{ option.name }}</span>\n\
  <UcSuggestCompanyOption2 v-if=\"option.id\" :option=option></UcSuggestCompanyOption2>\n\
</div>",
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_script_8234_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2248226175642056_script_8234, alias=undefined
    this.onOptionSelected($event.data)
  }

  async act_2248226175642056_script_8234_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2248226175642056_script_8234, alias=undefined
    return {
      value: () => this.act_2248226175642056_script_8234_getActionArgs_value($event),
    }
  }

  async evh_2248226175642056_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_optionSelected.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_8232: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_8231: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_2248226175642056_script_8234: actions.ScriptAction;
    evh_2248226175642056_optionSelected_8233: actions.EventHandlerImpl;
    evh_2248226175642056_optionSelected: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_8232 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_8231 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_8232,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_8231],
      }
    );
    const act_2248226175642056_script_8234 = new actions.ScriptAction(
      {
        actionArgs: this.act_2248226175642056_script_8234_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_optionSelected_8233 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_script_8234,
        event: "optionSelected",
        displayName: "script",
      }
    );
    const evh_2248226175642056_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_optionSelected_8233],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_8232,
      evh_7315092382398562_reload_8231,
      evh_7315092382398562_reload,
      act_2248226175642056_script_8234,
      evh_2248226175642056_optionSelected_8233,
      evh_2248226175642056_optionSelected,
    }
  }
}

Vue.component("UcRegisterEntryPartnerSelector", UcRegisterEntryPartnerSelector);

</script>